import Hero from "./components/Hero";

export default function Home() {
  return (
    <main className="relative bg-background-50 text-foreground-950 min-h-screen">
      <Hero />
    </main>
  );
}